/*
 * this file handles different endpoints for dev (localhost) and prod builds of Donna
 * we want to use the API locally (via localhost url) when developing,
 * and via prod url in production
 */

import { environment } from '../environments/environment';


if ( environment.production ) {
	var base = 'https://donna.semway.net/api';
} else if ( environment.staging ) {
	var base = 'https://dd.semway.net/api';
} else {
	// var base = 'http://localhost:8888/donna/frontend/web/dist/api';
	var base = 'http://localhost:8888/donna/frontend/web/src/api';
}


class Api {

	base = base;

}

export const api = new Api();


// WEBPACK FOOTER //
// ./src/app/api.ts